import { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Select, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

interface AddGroupProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const AddFeatureGroup: React.FC<AddGroupProps> = ({ open, setOpen }) => {

  const [selectedCategories, setSelectedCategories] = useState<string[]>(["default"]);
  const categories = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment", "Spare Parts", "Car Accessories"];
  const handleCategoryChange = (event: any) => {
    const value = event.target.value as string[];
    if (value.length > 1 && value.includes("default")) {
      setSelectedCategories(value.filter(v => v !== "default"));
    } else {
      setSelectedCategories(value);
    }
  };

  return (
    <Modal className="modal rejectReason_modal" open={open}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Feature Group</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="form ">
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Group Name</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Group Name"
                />
              </div>

              <div className="control_group w_100">
                <label htmlFor="type">Feature Group Type</label>
                <Select fullWidth hiddenLabel defaultValue="default">
                  <MenuItem value="default" disabled>Select Feature Group Type</MenuItem>
                  <MenuItem value="0">Any</MenuItem>
                  <MenuItem value="1">Interior</MenuItem>
                  <MenuItem value="2">Exterior</MenuItem>
                </Select>
              </div>

              <div className="control_group">
                <label>Category</label>
                <Select
                  multiple
                  fullWidth
                  hiddenLabel
                  value={selectedCategories}
                  onChange={handleCategoryChange}
                  renderValue={(selected) =>
                    (selected as string[])
                      .filter(v => v !== "default")
                      .join(", ") || "Select Categories"
                  }
                >
                  <MenuItem value={"default"} disabled>Select Categories</MenuItem>
                  {categories.map((category) => (
                    <MenuItem key={category} value={category}>
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="control_group w_100">
                <label htmlFor="type">Field Type</label>
                <Select fullWidth hiddenLabel defaultValue="default">
                  <MenuItem value="default" disabled>Select Field Type</MenuItem>
                  <MenuItem value="0">Select</MenuItem>
                  <MenuItem value="1">input</MenuItem>
                  <MenuItem value="2">Checkbox</MenuItem>
                  <MenuItem value="3">Radio</MenuItem>
                  <MenuItem value="4">Yes/No</MenuItem>
                </Select>
              </div>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddFeatureGroup;
